<template>
  <div>
    <select name="" v-model="sort" id="" class="form__select dashboard__filter">
      <option :value="null" disabled selected>Filter</option>
      <option value="all">All</option>
      <option value="pending">Pending</option>
      <option value="canceled">Canceled</option>
      <option value="active">Active</option>
      <option value="paid">Paid</option>
      <option value="inactive">Inactive</option>
      <option value="expired">Expired</option>
      <option value="expire-soon">Expire Soon</option>
      <option value="past-due">Past Due</option>
      <option value="cancelling">Cancelling</option>
    </select>
    <div class="dashboard__container ">
      <input
        type="text"
        class="form__input dashboard__search"
        v-model="searchQuery"
        placeholder="Search by member's name"
      />
      <svgicon
        icon="cancel"
        class="cancel_icon"
        @click.prevent="clearSearchBar"
      ></svgicon>
    </div>

    <div
      class="dashboard__payment-history-wrap dashboard__overview-table"
      v-if="subscriptions.length > 0 && returnedData"
    >
      <table class="dashboard__payment-history-table">
        <thead>
          <tr>
            <th class="dashboard__payment-history-table-heading"></th>
            <th class="dashboard__payment-history-table-heading">Member</th>
            <th class="dashboard__payment-history-table-heading">Space name</th>

            <th class="dashboard__payment-history-table-heading">Sub type</th>
            <th class="dashboard__payment-history-table-heading">sub cost</th>
            <th class="dashboard__payment-history-table-heading">Status</th>
            <th class="dashboard__payment-history-table-heading">Start date</th>
            <th class="dashboard__payment-history-table-heading">end date</th>
          </tr>
        </thead>
        <tbody>
          <router-link
            tag="tr"
            :to="
              `/subscription-details/${toBase64(
                subscription.id
              )}?page=${getPages}&currentPage=${curPage}`
            "
            v-for="(subscription, index) in searchTable(filteredSubscription)"
            :key="index"
            class="dashboard__table-row"
          >
            <td
              class="dashboard__payment-history-table-data dashboard__listing-table"
            >
              {{ pageNumber(index + 1) }}
            </td>
            <td class="dashboard__payment-history-table-data">
              {{
                `${subscription.user_kyc.userKyc.firstname} ${subscription.user_kyc.userKyc.lastname} `
              }}
            </td>
            <td class="dashboard__payment-history-table-data">
              {{ subscription.space_name }}
            </td>
            <td class="dashboard__payment-history-table-data">
              {{ subscription.sub_plan | capitalize }}
            </td>
            <td
              class="dashboard__payment-history-table-data"
              v-html="
                getCurrentAmount(subscription.price, subscription.currency)
              "
            ></td>
            <td class="dashboard__payment-history-table-data">
              <span
                class="dashboard__payment-history-table-status"
                :class="[
                  { pending: subscription.status == 'pending' },
                  { cancelled: subscription.status == 'canceled' },
                  { cancelled: subscription.status == 'cancelled' },
                  { approve: subscription.status == 'active' },
                  { approve: subscription.status == 'paid' },
                  { expired: subscription.status == 'expired' },
                  { decline: subscription.status == 'inactive' },
                  { expireSoon: subscription.status == 'expire-soon' },
                  { pastDue: subscription.status == 'past-due' },
                  { cancelling: subscription.status == 'cancelling' }
                ]"
                >{{ subscription.status | capitalize }}</span
              >
            </td>
            <td class="dashboard__payment-history-table-data">
              {{ formatDate(subscription.start_date) }}
            </td>
            <td class="dashboard__payment-history-table-data">
              {{ formatDate(subscription.end_date) }}
            </td>
          </router-link>
        </tbody>
      </table>
    </div>
    <!-- Empty subscription result -->
    <div v-if="!loader && subscriptions.length === 0 && !error">
      <empty-result />
    </div>
    <!-- error-->
    <div v-if="!loader && error">
      <error />
    </div>

    <div class="dashboard__pagination">
      <b-pagination
        v-if="subscriptions.length > 0 && returnedData"
        pills
        v-model="curPage"
        :total-rows="count"
        :per-page="pageSize"
        prev-text="Prev"
        next-text="Next"
        first-number
        last-number
        @change="handlePagination"
      ></b-pagination>
    </div>
    <div class="dashboard__empty" v-if="!returnedData">
      <div class="dashboard__booking-empty">
        <img
          src="../../assets/illustrations/noBookings.svg"
          alt=""
          class="img-fluid"
        />
      </div>
      <p class="dashboard__booking-empty-text">
        You don’t have any subscription yet.
      </p>
    </div>
    <loader :loader="loader"></loader>
  </div>
</template>
<script>
import loader from "../resuables/loader";
import { getSubscriptions } from "../../../services/subscription";
import EmptyResult from "../general/emptyResult.vue";
import Error from "../general/error.vue";
import {
  formatCurrencyAmount,
  sumBookingPrice,
  formatReadbleDate
} from "../../utils";
export default {
  name: "SubscriptionsTable",
  components: {
    loader,
    EmptyResult,
    Error
  },
  data: () => {
    return {
      subscriptions: [],
      subscriptionsLoader: true,
      formatCurrencyAmount,
      returnedData: true,
      loader: false,
      sort: "all",
      filteredSubscription: [],
      searchQuery: "",
      currentPage: 1,
      pageSize: 20,
      count: 0,
      status: "",
      error: false
    };
  },
  methods: {
    clearSearchBar() {
      this.searchQuery = "";
      this.getSubscriptions();
    },
    async getSubscriptions() {
      this.loader = true;
      const data = await getSubscriptions(
        this.getPages,
        this.pageSize,
        this.status
      );
      try {
        this.subscriptions = data.data.subscriptions;
        this.count = data.data.totalSubcriptions;
        this.filteredSubscription = this.subscriptions;
        this.loader = false;
      } catch (err) {
        this.loader = false;
        this.error = true;
        return err;
      }
    },
    pageNumber(index) {
      if (this.currentPage < 2) {
        return index;
      } else {
        return this.pageSize * (this.currentPage - 1) + index;
      }
    },
    handlePagination(value) {
      this.currentPage = value;
      this.$router.push(
        `/subscription?page=${this.currentPage}&status=${this.status}`
      );
    },

    searchTable(searchableRows) {
      return searchableRows.filter(preset => {
        let returnedSearch = new RegExp("(" + this.searchQuery + ")", "i");
        if (this.searchQuery == "") {
          return preset;
        } else {
          return (
            preset.user_kyc.userKyc.firstname.match(returnedSearch) ||
            preset.user_kyc.userKyc.lastname.match(returnedSearch)
          );
        }
      });
    },
    formatDate(date) {
      return formatReadbleDate(date);
    },
    toBase64(data) {
      return btoa(data);
    },
    getCurrentAmount(price, currency) {
      if (price) {
        return formatCurrencyAmount(price.amount, currency);
      }
    }
  },
  watch: {
    $route() {
      this.getSubscriptions();
    },
    sort(newValue) {
      this.page = 1;
      if (newValue === "all") {
        this.status = "";
        this.$router.replace(`/subscription?page=1`);
        this.getSubscriptions();
      } else {
        this.status = newValue;
        this.$router.replace(`/subscription?page=1&status=${this.status}`);
        this.getSubscriptions();
      }
    }
  },
  filters: {
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    formatNowDate(value) {
      if (!value) return "";
      if (value) {
        return moment(value).fromNow();
      }
    },
    capitalizeFirstLetter(value) {
      if (!value) return "";
      if (value) {
        return value.charAt(0).toUpperCase() + value.slice(1);
      }
    }
  },
  computed: {
    getPages() {
      return this.$route.query.page || 1;
    },
    curPage: {
      get() {
        return this.$route.query.page || 1;
      },
      set(value) {
        this.currentPage = value;
      }
    }
  },
  async mounted() {
    const { page, status } = this.$route.query;
    if (page) {
      this.currentPage = Number(page);
    }

    if (status) {
      this.status = status;
    }
    await this.getSubscriptions();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/subscription.vue